<template>
  <EdroneButtonIcon
    :disabled="!isValidEmail && !phone"
    :tooltip="trans._inbox.customer.footer.buttons.send"
    type="plain"
    unique-id="8fda8cf9-d741-41b6-a3a3-1cab005b99b0"
    @click="handleGoToNewMessage"
  >
    <font-awesome-icon icon="fa-light fa-envelope" />
  </EdroneButtonIcon>
</template>

<script setup lang="ts">
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import { useInboxConversations } from "../Inbox/machines/machineInboxConversations";
import { Conversation, useInboxActor } from "vue-app/pages/machines/machinePageInbox";
import { Ref, watch } from "vue";
import { useSelector } from "@xstate-4/vue";

interface Props {
  isValidEmail: boolean;
  phone: string | null;
  email: string | null;
  isPinned: boolean;
  hasCloseTag: boolean;
  customerId: number;
}

interface Emits {
  close: [];
  updateCustomer: [number];
}

const emit = defineEmits<Emits>();

const { isValidEmail, phone, email, isPinned, hasCloseTag, customerId } = defineProps<Props>();

const inboxActor = useInboxActor();
const inboxConversationsActor = useInboxConversations(inboxActor);

const handleGoToNewMessage = () => {
  sessionStorage.setItem(
    "newMessageContext",
    JSON.stringify({
      email: isValidEmail ? email : "",
      phone: phone || "",
      subject: "",
      body: "",
      selectedTemplate: null,
    })
  );

  if (isPinned) {
    emit("close");
  }

  inboxConversationsActor.send("OPEN_NEW_MESSAGE_MODAL");
};

if (inboxActor) {
  const selectedConversation: Ref<Conversation | null> = useSelector(
    inboxActor,
    (state) => state.context.selectedConversation
  );

  watch(
    selectedConversation,
    (conversation) => {
      if (!hasCloseTag && conversation?.customerId !== customerId) {
        emit("updateCustomer", conversation?.customerId || conversation?.conversationCustomers[0].customerId || 0);
      }
    },
    { deep: true }
  );
}
</script>
